import {Component, OnInit} from "@angular/core";
import {NotificationsGqlModel} from "../notifications/notifications.gql-model";
import {exposeComponentInDebugMode} from "../misc/expose-component-in-debug-mode.decorator";
import {SearchHelpers} from "../helpers/search-helper";
import {NgSwitch} from "@angular/common";
import {NotificationsService} from "../notifications/notifications.service";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 10;

@Component({
  templateUrl: "./my-tasks.template.pug",
  providers: [NgSwitch],
})
@exposeComponentInDebugMode()
export class MyTasksComponent implements OnInit {
  error: Error;
  tasks: NotificationsGqlModel[] = [];
  filteredTasks: NotificationsGqlModel[] = [];
  displayedTasks: NotificationsGqlModel[] = [];

  currentPage: number = DEFAULT_PAGE;
  pageSize: number = DEFAULT_PAGE_LIMIT;
  maxPages: number;
  searchText: string = "";

  constructor(private notificationsService: NotificationsService) {}

  updateDisplay() {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    // filtered: apply search
    // displayed: apply page

    this.filteredTasks = this.tasks.filter((task) => {
      if (this.searchText) {
        const values = [
          task.projectName,
          task.targetName,
          task.readableTargetType,
          task.readableStepName,
        ];

        const searchFailures = SearchHelpers.tokenizeString(this.searchText) // split on spaces but consider "" and ''
          .map(v => SearchHelpers.stripQuotes(v)) // strip quotes on ends if present
          .map(v => SearchHelpers.cleanParam(v)) // sanitize to create regexp
          .map(v => new RegExp(v, "i")) // create regexp
          .map(re => values.some(v => re.test(v))) // test regexp against all asset values
          .filter(it => it === false) // don't care about success
          .length;

        if (searchFailures) return false;
      }

      return true;
    });

    this.displayedTasks = this.filteredTasks.slice(start, end);
    this.recalculateMaxPages();
  }

  private recalculateMaxPages() {
    this.maxPages = Math.ceil(this.filteredTasks.length / (+this.pageSize));
  }

  onListControlsChange(event) {
    switch (event["key"]) {
      case "page":
        this.currentPage = event["value"];
        break;
      case "search":
        this.currentPage = DEFAULT_PAGE;
        this.searchText = event["value"];
        break;
      case "limit":
        this.currentPage = DEFAULT_PAGE;
        this.pageSize = event["value"];
        break;
      default:
        break;
    }
    this.updateDisplay();
  }

  ngOnInit() {
    this.notificationsService.notifications.subscribe(
      (tasks) => {
        this.error = undefined;
        this.tasks = tasks;
        this.recalculateMaxPages();
        this.updateDisplay();
      },
      (error) => {
        this.error = error;
      },
    );
  }
}
